import script from "./Notice.vue?vue&type=script&setup=true&lang=js"
export * from "./Notice.vue?vue&type=script&setup=true&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=6e68f382&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e68f382"]])

export default __exports__